import React, { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import { constants } from 'services/core/config';
import { useEmailRecaptcha } from '../../context/EmailRecaptchaContext';

export const EmailRecaptcha: React.FC = () => {
  const { recaptchaChange, recaptchaExpire, isVisible, errorVisible, setResetRecaptchaCallback } = useEmailRecaptcha();
  const { t } = useTranslation('recaptcha');

  const ref = useRef<any>({ reset: () => null });

  const resetRecaptcha = () => {
    ref.current.reset();
  };

  useEffect(() => {
    setResetRecaptchaCallback(() => resetRecaptcha);
  }, []);

  return (
    <div className="redo-register-email-recaptcha-container" data-testid="first-access-email-recaptcha">
      {isVisible && (
        <ReCAPTCHA
          sitekey={constants?.recaptcha?.siteKey}
          size="normal"
          ref={ref}
          onChange={recaptchaChange}
          onExpired={recaptchaExpire}
          data-testid="first-access-email-recaptcha-input"
        />
      )}

      <div data-testid="first-access-email-recaptcha-error-message">
        {errorVisible && <p>{t('validate_message')}</p>}
      </div>
    </div>
  );
};
